import React from "react";
import { Box, Drawer, IconButton } from "@mui/material";
import CustomText, { textStyles } from "../../../../components/CustomText";
import profilecross from "../../../../assets/profilecross.svg";
import StatusDropdown from "../../../../components/StatusDropdown";
import document1 from "../../../../assets/document1.svg"; // ✅ pdf icon
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";

const ViewDrawer = ({ open, onClose, row }) => {
  const { t } = useTranslation();

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const localDateTime = convertUTCToLocalDateTime(dateString, { locale: "en-GB" });
    return localDateTime === "—" ? "-" : localDateTime;
  };

  const InfoBox = ({ children }) => (
    <Box
      mt={2}
      sx={{
        border: "1px solid #091E4224",
        borderRadius: "10px",
        px: 2,
        py: 2,
      }}
    >
      {children}
    </Box>
  );

  const InfoRow = ({ label, value }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <CustomText
        sx={{
          ...textStyles.h1,
          fontSize: 16,
          fontWeight: 400,
          color: "#5E5C5C",
        }}
      >
        {label}
      </CustomText>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {value}
      </Box>
    </Box>
  );

  if (!row) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: 500, backgroundColor: "white" },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 2,
          py: 1,
          borderBottom: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
              fontFamily: "Poppins, sans-serif",
            }}
          >
           {t("documentsHeading")} #{row.id}
          </CustomText>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ px: 2, pb: 2, mt: 2 }}>
        <InfoBox>
          <InfoRow 
            label={t("documents.th.id") || "ID"} 
            value={row.id || "-"} 
          />

          <InfoRow 
            label={t("documents.th.documentName") || "Document Name"} 
            value={row.name || "-"} 
          />

   <InfoRow 
            label=  {t("documents.th.description") || "Description"}
            value={row.description || "-"} 
          />
         <InfoRow 
            label=  {t("documents.th.subject") || "Subject"}
            value={row.subject || "-"} 
          />


          {/* File Type Row */}
          <InfoRow
            label={t("documents.th.fileType") || "File Type"}
            value={
              (row.fileType || "").toLowerCase().includes("pdf") ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img src={document1} alt="pdf" style={{ width: 24, height: 24 }} />
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textTransform: "uppercase",
                    }}
                  >
                    {row.fileType || "-"}
                  </CustomText>
                </Box>
              ) : (
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textTransform: "uppercase",
                  }}
                >
                  {row.fileType || "-"}
                </CustomText>
              )
            }
          />

          <InfoRow 
            label={t("documents.th.uploadedAt") || "Uploaded At"} 
            value={formatDateTime(row.uploadedAt)} 
          />
        </InfoBox>

        {/* PDF File Preview Box */}
    <InfoBox>
          {row.documentUrl && row.documentUrl.toLowerCase().includes("pdf") && (
    <Box
sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "#f9f9f9",
      borderRadius: "6px",
      p: 2,
      width: "100%",
      height: 250,
      textAlign: "center",
}}
    >
      <img
        src={document1}
        alt="PDF Document"
        style={{ width: 60, height: 60, marginBottom: 8 }}
      />
      <CustomText
        sx={{
          fontSize: 14,
          fontWeight: 400,
          color: "#172B4D",
          textAlign: "center",
          wordBreak: "break-all",
        }}
      >
                {row.name || row.documentUrl.split("/").pop()}
      </CustomText>
    </Box>
  )}
          {row.documentUrl && (
        <Box sx={{ textAlign: "right", mt: 1 }}>
        <CustomButton
                label={t("requestDetails.viewDocument") || "View Document"}
          size="small"
          onClick={() =>
                  window.open(row.documentUrl, "_blank", "noopener,noreferrer")
          }
        />
      </Box>
          )}
  </InfoBox>
      </Box>
    </Drawer>
  );
};

export default ViewDrawer;